/**
 * Turn Off the Lights
 *
 * Video dimmer; exposes its player-status script to all origins.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 4.6.6.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'bfbmjmiodbnnpllbbbfblcplfjjepjdn';
export const turnOffTheLights: ExtensionDefinition = {
  id: ID,
  name: "Turn Off the Lights",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Video dimmer; exposes its player-status script to all origins.",
  signals: [
    { id: 'war-scripts-video-player-status-js', kind: 'web-accessible-resource',
      description: 'Fetch scripts/video-player-status.js, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'scripts/video-player-status.js') },
    { id: 'war-scripts-fps-block-js', kind: 'web-accessible-resource',
      description: 'Fetch scripts/fps-block.js, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'scripts/fps-block.js') },
  ],
};
